import * as React from 'react';

import {MAILCHIMP_EMAILS} from '../../constants';
import {FormEmails} from '../../forms';

import {StageItemSidebar} from './sidebar/stage-item-sidebar';

type OwnProps = {
    isNew: boolean;
    entityId: string | null | undefined;
    parentId: string;
};

type Props = OwnProps;

export class MailChimpStageSubscriptionEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        return (
            <StageItemSidebar
                onSave={this.handleSidebarFormSave}
                parentId={this.props.parentId}
                title={
                    this.props.isNew ? 'New MailChimp subscription' : 'Edit MailChimp subscription'
                }
            >
                <FormEmails
                    type={MAILCHIMP_EMAILS}
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    stageId={this.props.parentId}
                    entityId={this.props.entityId}
                />
            </StageItemSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
